import apiClient from "./axios";

/**
 * 场景化提示词相关API
 * 遵循API_GUIDELINES.md中的标准CRUD函数签名规范
 */
const scenarioContextApi = {
    /**
     * 获取场景化上下文列表 - 标准CRUD命名
     * @param {Object} params - 请求参数 (应包含 page 和 page_size)
     * @returns {Promise<Array>} 场景化上下文列表
     */
    getList: (params = {}) => apiClient.get("/v1/scenario-contexts", { params }),

    /**
     * 获取单个场景化上下文 - 标准CRUD命名
     * @param {number} id - 场景化上下文ID
     * @returns {Promise<Object>} 场景化上下文详情
     */
    getById: (id) => apiClient.get(`/v1/scenario-contexts/${id}`),

    /**
     * 创建场景化上下文 - 标准CRUD命名
     * @param {Object} data - 场景化上下文数据
     * @returns {Promise<Object>} 创建结果
     */
    create: (data) => apiClient.post("/v1/scenario-contexts", data),

    /**
     * 更新场景化上下文 - 标准CRUD命名，必须使用对象参数
     * @param {Object} params - 包含id和data的对象参数
     * @returns {Promise<Object>} 更新结果
     */
    update: ({ id, data }) => apiClient.put(`/v1/scenario-contexts/${id}`, data),

    /**
     * 删除场景化上下文 - 标准CRUD命名
     * @param {number} id - 场景化上下文ID
     * @returns {Promise<Object>} 删除结果
     */
    delete: (id) => apiClient.delete(`/v1/scenario-contexts/${id}`),

    /**
     * 匹配场景化上下文 - 自定义方法
     * @param {Object} data - 匹配参数
     * @returns {Promise<Object>} 匹配结果
     */
    match: (data) => apiClient.post("/v1/scenario-contexts/match", data),

    /**
     * 获取所有Agent名称 - 自定义方法
     * @returns {Promise<Array>} Agent名称列表
     */
    getAgentNames: () => apiClient.get("/v1/scenario-contexts/agent-names"),
};

export { scenarioContextApi };
